export default __webpack_public_path__ + "static/media/portgeneric.ccfe3b5b.jpg";